export default {
    name: 'WithGlobalPermission',
    props: {
        // path format eg 'Orders.list'
        permission: {
            type: String,
            required: true
        }
    },

    inject: {
        checkPermission: {
            default: () => false
        }
    },

    computed: {
        hasPermission() {
            if (!this.permission) return false;

            return this.checkPermission(this.permission);
        }
    },

    render() {
        if (this.hasPermission) {
            return this.$slots.default && this.$slots.default();
        }

        return null;
    }
};
